import Router from 'preact-router';
import { render } from 'preact';
import App from './app';

import './index.less';

const Main = () => (
  <Router>
    <App path="/:username" />
    <App path="/t/:username" />
  </Router>
);

render(<Main />, document.body);
